<nz-space class="mobile-report-control">
  <app-bir-supplier-class-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="code" [type]="type">
  </app-bir-supplier-class-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-bir-supplier-class-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="code" [type]="type">
  </app-bir-supplier-class-select>
</nz-space>
